import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import UtilsUrl from "../utils/UtilsUrl";
import { productImageSrc, onProductImageError } from "../utils/productImage";

const DataTableProductsSell = ({ listProduits }) => {
  const navigate = useNavigate();

  const [products, setProducts] = useState(listProduits);

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  function logoFormatter(cell, row) {
    return (
      <span>
        <img
          alt=""
          src={productImageSrc(row.product.imagePath)}
          onError={onProductImageError}
          class="rounded-circle"
          style={{ width: "50px", height: "50px" }}
        ></img>
      </span>
    );
  }

  function buttonFormatter(cell, row) {
    return (
      <span>
        {console.log("cell", row)}
        <button
          className="btn btn-dark"
          onClick={(e) => {
            sessionStorage.setItem("idProductStock", row.product.id);
            const pdfWindow = window.open();
            pdfWindow.location.href = "/addProductStockToSell";
            // navigate(`/addProductStockToSell`);
          }}
        >
          <h6>
            <small>
              <i class="fas fa-pencil-alt"></i>
            </small>
          </h6>
        </button>
      </span>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "Image",
      formatter: logoFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "product.name",
      text: "Libellé",
    },
    {
      dataField: "product.productCode",
      text: "Code article",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "product.barcode",
      text: "Code à barre",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "id",
      text: "Configurer",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Produits</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};
export default DataTableProductsSell;
